import * as React from 'react';
import CurrencyQuery from '../../../../../components/Query/Currencies/Currencies';
import PricesByWeightList, { IPricesByWeightProps } from './PricesByWeight';

const PricesByWeight = (props: IPricesByWeightProps) => {
  return (
    <React.Fragment>
      <CurrencyQuery>
        {({ currencies }: any) => {
          if (currencies && !currencies.loading) {
            return (
              <PricesByWeightList 
                {...props}
                currencies={currencies.currencies}
              />
            );
          }

          return null;
        }}
      </CurrencyQuery>
    </React.Fragment>
  );
};

export default PricesByWeight;


// WEBPACK FOOTER //
// ./src/scenes/DeliveryMethods/DeliveryMethodDetail/components/PricesByWeight/index.tsx